import { useCurrentUser } from 'hooks/auth';

import { CURRENCY_SIGN_MAP } from '@libs/ui/components/job/utils';

export const useCurrentCompanyCurrency = () => {
  const { data } = useCurrentUser();
  const company = data?.currentCompanyUser?.company;

  return company?.currency;
};

export const useCurrentCompanyCurrencySign = () => {
  const currency = useCurrentCompanyCurrency();

  return CURRENCY_SIGN_MAP[currency || 'USD'];
};
